module.exports = __webpack_public_path__ + "static/media/jaybox_logo_light_full.b361c5d6.svg";